import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '../api/queryKeys'
import {
  fetchSurveyForms,
  saveSurveyForm,
  updateSurveyForm,
  deleteSurveyForm,
} from '../api/surveyForm'

export function useSurveyFormList(clientId: string) {
  return useQuery({
    queryKey: queryKeys.surveyForm.list(clientId),
    queryFn: () => fetchSurveyForms(clientId),
    enabled: !!clientId,
  })
}

export function useSaveSurveyFormMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (surveyFormData: Record<string, string | number>) =>
      saveSurveyForm(clientId, surveyFormData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.surveyForm.list(clientId) })
    },
  })
}

export function useUpdateSurveyFormMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      surveyFormId,
      surveyFormData,
    }: {
      surveyFormId: string
      surveyFormData: Record<string, string | number>
    }) => updateSurveyForm(surveyFormId, clientId, surveyFormData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.surveyForm.list(clientId) })
    },
  })
}

export function useDeleteSurveyFormMutation(clientId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (surveyFormId: string) => deleteSurveyForm(surveyFormId, clientId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.surveyForm.list(clientId) })
    },
  })
}
